// This is a part of the Cadcorp SIS source code. 
// Copyright (c) NEC Software Solutions UK Limited 1991-2026 
import Vue from 'Vue';
import { Module } from 'Vuex';
import { openDB } from 'idb';

// Abstractions
import { IBookmarkState, IRootState, IBookmark } from '../../../../CommonScripts/Abstractions';

declare var Cadcorp: any;

const theState: IBookmarkState = {
    bookmarks: null,
    initialised: false
};
const bookmarkState: Module<IBookmarkState, IRootState> = {
    namespaced: true,
    state: theState,
    mutations: {
        setBookmarks(state, bookmarks) {
            state.bookmarks = bookmarks;
        },
        setInitialised(state, initialised) {
            state.initialised = initialised;
        },
        addBookmark(state, bookmark) {
            if (state.bookmarks === null) {
                state.bookmarks = [bookmark];
            }
            else
                state.bookmarks.push(bookmark);
        },
        addBookmarks(state, bookmarks) {
            if (state.bookmarks === null)
                state.bookmarks = bookmarks;
            else
                state.bookmarks.push.apply(state.bookmarks, bookmarks);
        },
        removeBookmark(state, bookmark) {
            var foundIndex = state.bookmarks.indexOf(bookmark);
            if (foundIndex !== -1) {
                state.bookmarks.splice(foundIndex, 1);
            }
        }
    },
    getters: {
        hasName: (state) => (name): boolean => {
            var retVal = false;
            if (state.bookmarks !== null && state.bookmarks.length > 0) {
                var found = state.bookmarks.filter((element: IBookmark) => element.name === name);
                retVal = found && found.length > 0;
            }
            return retVal;
        },
        homeBookmark: (state): IBookmark => {
            var retVal = null;
            if (state.bookmarks !== null && state.bookmarks.length > 0) {
                var found = state.bookmarks.filter((element: IBookmark) => element.isHome);
                retVal = found && found.length > 0 ? found[0] : null;
            }
            return retVal;
        }
    },
    actions: {
        addBookmark(context, bookmark) {
            var theDB = null;
            openDB(context.rootState.localStorageName)
                .then((db) => {
                    theDB = db;
                    return db.transaction('bookmark', 'readwrite');
                }).
                then((transaction) => {
                    return transaction.objectStore('bookmark').add(bookmark);
                })
                .then((newKey) => {
                    bookmark.id = newKey;
                    context.commit('addBookmark', bookmark);
                    theDB.close();
                })
                .catch((error) => {
                    console.log(`error adding bookmark to database, ${error}`);
                }
            );
            return bookmark;
        },
        updateBookmarks(context, bookmarks) {
            var theDB = null;
            openDB(context.rootState.localStorageName)
                .then((db) => {
                    theDB = db;
                    return db.transaction('bookmark', 'readwrite');
                }).
                then((transaction) => {
                    var pArray = [];
                    for (var count = 0; count < bookmarks.length; count++) {
                        var bookmark = bookmarks[count];
                        pArray.push(transaction.objectStore('bookmark').put(bookmark).catch((error) => {
                            console.log(`error updating bookmark ${error}`);
                        }));
                    }
                    return pArray;
                })
                .then(() => {
                    theDB.close();
                })
                .catch((error) => {
                    console.log('error opening bookmarks database');
                });
        },
        getBookmarksFromServer(context) {
            var url = `${context.rootState.baseUrl}Bookmark/${context.rootState.mapName}`;
            var ajax = new Cadcorp.Core.AjaxWrapper(context.rootState.ajaxDefaults);
            return ajax.get(url, null)
                .then(response => {
                    var bookmarks = [];
                    if (response.data && response.data.length > 0) {
                        for (var count = 0; count < response.data.length; count++) {
                            var tmpBookmark = response.data[count];
                            var location = { x: tmpBookmark.x, y: tmpBookmark.y, epsgCode: null }
                            var bookmark = {
                                name: tmpBookmark.name,
                                isHome: false,
                                isUserCreated: false,
                                resolution: tmpBookmark.resolution,
                                location: location,
                            };
                            bookmarks.push(bookmark);
                        }
                        context.commit('addBookmarks', bookmarks);
                    }

                    return bookmarks;
                });
        },
        getLocalBookmarks(context) {
            var theDB = null;
            return openDB(context.rootState.localStorageName)
                .then((db) => {
                    theDB = db;
                    return db.transaction('bookmark', 'readonly').objectStore('bookmark').getAll();
                }).
                then((localBookmarks) => {
                    if (localBookmarks && localBookmarks.length > 0) {
                        context.commit('addBookmarks', localBookmarks);
                    }
                    return localBookmarks;
                })
                .then((response) => {
                    theDB.close();
                    return response;
                })
                .catch((error) => {
                    console.log('error opening bookmarks database');
                });
        },
        getLocalBookmarksForMap(context, mapName) {
            var theDB = null;
            return openDB(context.rootState.localStorageName)
                .then((db) => {
                    theDB = db;
                    return db.transaction('bookmark', 'readonly').objectStore('bookmark').getAll();
                }).
                then((localBookmarks) => {
                    localBookmarks = localBookmarks.filter(b => b.mapName === mapName)
                    if (localBookmarks && localBookmarks.length > 0) {
                        context.commit('addBookmarks', localBookmarks);
                    }
                    return localBookmarks;
                })
                .then((response) => {
                    theDB.close();
                    return response;
                })
                .catch((error) => {
                    console.log('error opening bookmarks database');
                });
        },
        removeUserBookmark(context, bookmark) {
            var theDB = null;
            openDB(context.rootState.localStorageName)
                .then((db) => {
                    theDB = db;
                    return db.transaction('bookmark', 'readwrite').objectStore('bookmark').delete(bookmark.id);
                }).
                then((req) => {
                    context.commit('removeBookmark', bookmark);
                    return;
                })
                .then(() => {
                    theDB.close();
                })
                .catch((error) => {
                    console.log(`error removing bookmark ${error}`);
                });
            return bookmark;
        }
    }
}
export default bookmarkState;

